import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router";
import { memo, useState } from "react";
import { ACL_ACTION_TYPE } from "../utils/constants";
import { inject, observer } from "mobx-react";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const InternalConnectedDocumentPage = ({ aclStore, valueInit }) => {
  const [value, setValue] = useState(valueInit);
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      navigate("/internal-connected-document/incoming-document");
    } else if (newValue === 1) {
      navigate("/internal-connected-document/outgoing-document");
    }
  };
  return (
    <div className="pl-2 pr-2">
      <Box className="" sx={{}}>
        <Box sx={{}}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            {aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.menu__LIEN_THONG_VB
            ) && (
              <Tab
                className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0 "
                label="Văn bản đến"
                {...a11yProps(0)}
              />
            )}
            {aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.menu__LIEN_THONG_VB
            ) && (
              <Tab
                className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0"
                label="Văn bản đi"
                {...a11yProps(1)}
              />
            )}
          </Tabs>
        </Box>
      </Box>
    </div>
  );
};

export default memo(
  inject("aclStore")(observer(InternalConnectedDocumentPage))
);
